import React, { useEffect, useRef } from 'react';
import * as THREE from 'three'; 

const ThreeDScene = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const currentMount = mountRef.current;
    if (!currentMount) {
      return;
    }

    // Scene, Camera, Renderer setup
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, currentMount.clientWidth / currentMount.clientHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true    
    });
    renderer.setSize(currentMount.clientWidth, currentMount.clientHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    currentMount.appendChild(renderer.domElement);

    // --- CRITICAL: Set the renderer's background to fully transparent ---
    renderer.setClearColor(0x000000, 0); 
    // --- END CRITICAL ADDITION ---

    // --- LIGHTING ---
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
    scene.add(ambientLight);

    const pointLight1 = new THREE.PointLight(0xffcc00, 0.8, 100);
    pointLight1.position.set(5, 5, 5);
    scene.add(pointLight1);

    const pointLight2 = new THREE.PointLight(0x00ccff, 0.6, 100);
    pointLight2.position.set(-5, -5, -5);
    scene.add(pointLight2);

    // --- OBJECTS ---    
    const cubeGeometry = new THREE.BoxGeometry(4, 4, 4);
    const cubeMaterial = new THREE.MeshStandardMaterial({
      color: 0x0077ff,
      roughness: 0.5,
      metalness: 0.8,
      transparent: true, 
      opacity: 0.6,      
    });
    const cube = new THREE.Mesh(cubeGeometry, cubeMaterial);
    cube.position.set(0, 0, 0);
    scene.add(cube);

    const sphereGeometry = new THREE.SphereGeometry(2.5, 32, 32);
    const sphereMaterial = new THREE.MeshPhysicalMaterial({
      color: 0xff0077,
      clearcoat: 1.0,
      roughness: 0.2,
      metalness: 0.0,
      transparent: true,
      opacity: 0.7,
      transmission: 0.5
    });
    const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
    sphere.position.set(5, 2, -5);
    scene.add(sphere);

  
    const torusGeometry = new THREE.TorusGeometry(3, 1, 16, 100);
    const torusMaterial = new THREE.MeshStandardMaterial({
      color: 0x00ff00,
      roughness: 0.1,
      metalness: 0.9,
      transparent: true, 
      opacity: 0.6,      
    });
    const torus = new THREE.Mesh(torusGeometry, torusMaterial);
    torus.position.set(-5, -2, 3);
    scene.add(torus);

    // --- CAMERA POSITION ---
    camera.position.z = 15;

    // --- ANIMATION LOOP ---
    const animate = function () {
      requestAnimationFrame(animate);

      cube.rotation.x += 0.002;
      cube.rotation.y += 0.003;
      sphere.rotation.y += 0.005;
      sphere.rotation.x += 0.001;
      torus.rotation.x += 0.004;
      torus.rotation.y += 0.002;

      renderer.render(scene, camera);
    };
    animate();

    // --- RESIZE HANDLER ---
    const onWindowResize = () => {
      camera.aspect = currentMount.clientWidth / currentMount.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(currentMount.clientWidth, currentMount.clientHeight);
    };
    window.addEventListener('resize', onWindowResize);

    // --- CLEANUP ---
    return () => {
      window.removeEventListener('resize', onWindowResize);
      if (currentMount.contains(renderer.domElement)) {
          currentMount.removeChild(renderer.domElement);
      }
      renderer.dispose();
    };
  }, []);

  
  return <div ref={mountRef} style={{ width: '100%', height: '100%' }} />;
};

export default ThreeDScene;
